module.exports = __webpack_public_path__ + "img/epos1.d7b2d815.jpg";